<!-- Actual loading of heatmap is done with JS hook to agm-map, once loaded -->
<agm-map 
    [latitude]="start_lat" 
    [longitude]="start_lng" 
    [zoom]="start_zoom"
    (mapReady)="onMapLoad($event)">
</agm-map>
